module.exports = __webpack_public_path__ + "img/财务报表.bc8521ab.png";